import { forwardRef } from "react";

const Input = forwardRef(({ type, className, ...props }, ref) => {
  return (
    <input
      type={type}
      className={`awd-input ${className}`}
      ref={ref}
      {...props}
    />
  );
});

Input.defaultProps = {
  type: "text",
  className: "",
};

export default Input;
